import CAJA1050ResponseModel from '@/api/data/CAJ/CAJG1050/CAJA1050ResponseModel'
import CAJA1050RequestModel from '@/api/data/CAJ/CAJG1050/CAJA1050RequestModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAJG1050Service {
  /**
   *
   * @returns string base 64
   */
  public async callAPICAJA1050(): Promise<CAJA1050ResponseModel> {
    const caja1050RequestModel = new CAJA1050RequestModel()
    const caja1050ResponseModel: CAJA1050ResponseModel = <
      CAJA1050ResponseModel
    > await RestService.post(ApiUrlConstants.CAJA1050, caja1050RequestModel)
    return caja1050ResponseModel
  }
}
